module.exports = __webpack_public_path__ + "static/media/fa-globe-americas.421ea392.png";